import * as service from './service'
export default {
  namespace: 'recruitCertificationDesc',
  state: {
    stepList: []
  },
  effects: {
    * getAuthList ({ payload }, { call, put }) {
      const res = yield call(service.list, payload)
      yield put({
        type: 'save',
        payload: {
          stepList: res.data.data || []
        }
      })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
